<template>
  <div
    v-if="showNotification"
    class="notifications__item mb-3"
    style="cursor: pointer;">
    <slot />
    <div class="notifications-footer mt-1 text--grey05">
      <slot name="actions" />
      <app-checkbox
        :id="notification.id"
        :checked="checked"
        class="notifications-footer__btn mr-2"
        @input="onCheckRead">
        既読
      </app-checkbox>
    </div>
  </div>
</template>

<script>
import AppCheckbox from '@/components/parts/AppCheckbox'
import { mapState } from 'vuex'

export default {
  components: {
    AppCheckbox
  },
  props: {
    notification: {
      type: Object,
      required: true
    },
    lockGoalOption: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      checked: false,
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    showNotification() {
      // 鍵付きoptionがfalseのときには鍵付き目標に関連する活動記録やコメントの通知を表示しない
      if (!this.notification) return false
      if (this.lockGoalOption) return true
      if (this.notification.activityResult && this.notification.activityResult.goal.isLocked) return false
      if (this.notification.comment && this.notification.comment.activityResult.isLocked) return false
      return true
    }
  },
  methods: {
    onCheckRead() {
      this.checked = !this.checked
      this.$emit('check-read', this.notification.id)
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/stylesheets/member';
.notifications{
  &__item{
    border: solid 1px $grey10;
    border-radius: 8px;
    background-color: $white;
  }
}

.notifications-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  &__btn {
    padding: 16px 8px;
  }
}
</style>